// This file includes helper functions used throughout the app

import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import store from './../store';

// Load data from backend for specific element
export const loadElementData = async (url, element, page) => {
  await axios.get(url)
    .then(resp => (page[`${element}`] = resp.data))
    .catch(err => console.log(err));
}

export const consoleRed = (msg) => {
  console.log(`%c${msg}`, 'background: #ef2d40; color: #000000');
}

export const getRole = ()=> {
  var token = store.state.auth.token.Token;
  var base64Url = token.split('.')[1];
var base64 = base64Url.replace('-', '+').replace('_', '/');
return JSON.parse(window.atob(base64)).role
}
export const getTokenExpiry = ()=> {
  var token = store.state.auth.token.Token;
  var base64Url = token.split('.')[1];
var base64 = base64Url.replace('-', '+').replace('_', '/');
return JSON.parse(window.atob(base64)).exp
}
export const getDateNowFormatted = ()=> {
  var dateNow = Date.now()
  dateNow = dateNow.toString().slice(0,-3)
dateNow = parseInt(dateNow)
if (!isNaN(dateNow)){
  return dateNow
}else{
  return false
}
}

// html2canvas and jsPDF renderer
export const renderPDF = async (width, height, canvasID, orientation) => {
  let wid, hgt = 0;

  const canvas = await html2canvas(document.querySelector(`#${canvasID}`), {
    scale: 5,
    width: width,
    height: height
  });

  const img = canvas.toDataURL(
    "image/jpeg",
    (wid = canvas.width),
    (hgt = canvas.height)
  );

  const hratio = hgt / wid;
  const doc = new jsPDF(orientation, "pt", "a4")  
  doc.margins = {
    top: 40,
    bottom: 60,
    left: 40,
    width: 522
  };
  const widthImg = doc.internal.pageSize.width -40;
  const heightImg = widthImg * hratio;

  doc.addImage(img, "JPEG", 20, 20, widthImg, heightImg, "report", "FAST");

  return doc;
}

export const renderPDFTwoPages = async (width, height, canvasID, canvasIDPageTwo, orientation) => {
  let wid, hgt = 0;

  const canvas = await html2canvas(document.querySelector(`#${canvasID}`), {
    scale: 1,
    width: width,
    height: height
  });

  const img = canvas.toDataURL(
    "image/jpeg",
    (wid = canvas.width),
    (hgt = canvas.height)
  );


  const canvasPageTwo = await html2canvas(document.querySelector(`#${canvasIDPageTwo}`), {
    scale: 1,
    width: width,
    height: height
  });
  const imgPageTwo = canvasPageTwo.toDataURL(
    "image/jpeg",
    (wid = canvasPageTwo.width),
    (hgt = canvasPageTwo.height)
  );

  const hratio = hgt / wid;
  const doc = new jsPDF(orientation, "pt", "letter");
  const widthImg = doc.internal.pageSize.width;
  const heightImg = widthImg * hratio;

  doc.addImage(img, "JPEG", 0, 0, widthImg, heightImg, "report", "FAST");
  await doc.addPage()
  doc.addImage(imgPageTwo, "JPEG", 0, 0, widthImg, heightImg, "reportPageTwo", "FAST");

  return doc;
}
